import toastMessage from "../toastMessage";
import formatSelectData from "../formatSelectData";
import { getStorage } from "../storage";
import language from "../../language";
import { ROLE_SERVICE } from "../../constants/ROLES";
import { defineRole } from "../handleAccessRoles";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const fetchData = async (lng = "english", params) => {
  try {
    const user = await getStorage();
// eslint-disable-next-line no-unused-vars

    const { page, limit, type, name, q } = params;
// eslint-disable-next-line no-unused-vars

    if (!q || q === "") {
      delete params["q"];
    }

    // const canAccess = defineRole({
    //   roles: user.accessRole,
    //   menu: ROLE_SERVICE,
    //   operation: "read",
    // });

    // if (!canAccess) return;

    const options = {
      method: "GET",
      url: `${API_URL}/department`,
      params: {
        page: page,
        limit: limit,
        name,
        // hospital: hospital || hospitalRole,
        q: q || q !== "" ? q : undefined,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    if (type === "dropdown") {
      console.log(
        "I here >>>>",
        formatSelectData(data || queryRes.data, "name", "_id"),
      );
      return formatSelectData(data || queryRes.data, "name", "_id");
    }

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", language[lng].unable_fetch_departments);
  }
};

export default fetchData;

export const deleteDepartment = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_SERVICE,
      operation: "delete",
    });

    if (!canAccess) return;

    const options = {
      method: "DELETE",
      url: `${API_URL}/department`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_department);
  } catch (error) {
    toastMessage("error", language[lng].error_delete_department);
  }
};
